import { render, staticRenderFns } from "./MpCrossword2.vue?vue&type=template&id=5c9e4436&scoped=true&"
import script from "./MpCrossword2.vue?vue&type=script&lang=js&"
export * from "./MpCrossword2.vue?vue&type=script&lang=js&"
import style0 from "./MpCrossword2.vue?vue&type=style&index=0&id=5c9e4436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9e4436",
  null
  
)

export default component.exports